import React from 'react';

import { useTheme } from '@mui/material/styles';

function CalendarIcon() {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" className="valign-middle">
            <g stroke={theme.palette.icon.main} strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a3tyfs)">
                <path d="M12 2.667H4a2.667 2.667 0 0 0-2.667 2.666V12A2.667 2.667 0 0 0 4 14.666h8A2.667 2.667 0 0 0 14.667 12V5.333A2.667 2.667 0 0 0 12 2.666ZM5.333 1.333V4m5.334-2.667V4M1.333 6.667h13.334" />
            </g>
            <defs>
                <clipPath id="a3tyfs">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default CalendarIcon;
